// extracted by mini-css-extract-plugin
export var articleHeading = "eGovernment-module--articleHeading--BjYD9";
export var articleText = "eGovernment-module--articleText--xC0UO";
export var deliveryIcon = "eGovernment-module--deliveryIcon--DaHGi";
export var egButton = "eGovernment-module--egButton--QkwSR";
export var egButtonIcon = "eGovernment-module--egButtonIcon--yCkfj";
export var egButtons = "eGovernment-module--egButtons--mYTv4";
export var egDescription = "eGovernment-module--egDescription--xd1hj";
export var egovSection = "eGovernment-module--egovSection--VURZ4";
export var grantIcon = "eGovernment-module--grantIcon--S4L6T";
export var paymentIcon = "eGovernment-module--paymentIcon--2+Lia";